import styled from 'vue-styled-components'

const theme = {font: String}

const ThemedTitleLine = styled('div', theme)`
        font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
        letter-spacing: 0.337647px;
        font-weight: 600;
        font-size: 19px;
        line-height: 1.25;
`

export default ThemedTitleLine
